import { openDB } from 'idb';

const DB_NAME = 'db-adversaries';
const DB_VERSION = 1;
const STORE_NAME = 'db-adversaries-store';

export const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, {
          keyPath: 'id',
          autoIncrement: true,
        });
      }
    },
  });
};

export const addAdversary = async data => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  await store.add(data);
  await tx.done;
};

export const updateAdversary = async (idReport, newReport) => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  const allItems = await store.getAll();
  const item = allItems.find(item => item.idReport === idReport);
  if (item) {
    const updatedItem = { ...item, ...newReport };
    await store.put(updatedItem);
  }
  await tx.done;
};

export const getAdversaries = async () => {
  const db = await initDB();
  return db.getAll(STORE_NAME);
};

export const clearAdversaries = async () => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  await store.clear();
  await tx.done;
};

export const deleteAdversary = async key => {
  const db = await initDB();
  if (STORE_NAME) {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await store.delete(key);
  }
};
